import React from "react";
import styles from "./Button.module.scss";

type Theme = "primary" | "secondary" | "tertiary" | "danger-primary" | "danger-secondary";
type Size = "xs" | "sm" | "md" | "lg";

interface Props {
  children: string | JSX.Element;
  className?: string;
  attributes?: React.ButtonHTMLAttributes<HTMLButtonElement>;
  theme?: Theme;
  size?: Size;
  onClick?: React.MouseEventHandler;
}

const Button = ({ children, className = "", attributes = {}, theme = "primary", size = "md", onClick }: Props): JSX.Element => (
  <button className={`${styles.btn} ${styles[`theme-${theme}`]} ${styles[`size-${size}`]} ${className}`.trim()} {...attributes} onClick={onClick}>
    {children}
  </button>
);

export default Button;
